import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.131 10.589l6.469-6.47V2.423L9.131 8.892 6.229 5.988 2.4 9.817v1.696l3.829-3.828 2.902 2.904zM0 0v18l4-4h14V0H0zm16.8 12.8H3.503l-.352.351L1.2 15.103V1.2h15.6v11.6z" />
  </svg>
);

export default SvgComponent;
